import React from 'react';

export const Footer = () => {
  return (
    <footer className="mt-auto pt-12 pb-6 text-center">
      <p className="text-sm text-helper">
        A Curious Culture tool. Created by Marie Roker-Jones.
      </p>
    </footer>
  );
};

export default Footer;
